var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-progress',{attrs:{"type":"circle","percent":_vm.timeLeft * 100 / _vm.timeInSeconds,"format":function (_) { return (_vm.minutes + ":" + _vm.zeroFilledSeconds); },"stroke-color":_vm.color}})}
var staticRenderFns = []

export { render, staticRenderFns }